import {
  ChangeDetectorRef,
  ComponentFactory,
  ComponentFactoryResolver,
  ComponentRef,
  Directive,
  OnChanges,
  OnInit,
  Type,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { componentMap } from '../../component-map';
type a = Record<'string', 'string'>;
@Directive()
export abstract class WrapperComponentDirective implements OnChanges, OnInit {
  abstract componentName: string;
  @ViewChild('viewChild', { static: true, read: ViewContainerRef })
  viewChild: ViewContainerRef;
  componentRef: ComponentRef<any>;
  componentFactory: ComponentFactory<any>;

  constructor(private componentFactoryResolver: ComponentFactoryResolver) {}

  ngOnInit(): void {
    this.setComponent();
    this.passBindings();
  }

  ngOnChanges(): void {
    if (!this.componentRef) {
      return;
    }
    this.passBindings();
    this.invokeChangeDetection();
  }

  // Dynamically chooses which component to load inside the child container based on the componentMap.
  private setComponent(): void {
    this.componentFactory =
      this.componentFactoryResolver.resolveComponentFactory(
        // @ts-ignore
        componentMap[this.componentName],
      );
    this.viewChild.clear();
    this.componentRef = this.viewChild.createComponent(this.componentFactory);
  }

  private passBindings(): void {
    this.componentFactory.inputs.forEach((input) => {
      // @ts-ignore
      this.componentRef.instance[input.propName] = this[input.propName];
    });

    this.componentFactory.outputs.forEach((output) => {
      // @ts-ignore
      this.componentRef.instance[output.propName] = this[output.propName];
    });
  }

  private invokeChangeDetection(): void {
    this.componentRef.injector
      .get<ChangeDetectorRef>(ChangeDetectorRef as Type<ChangeDetectorRef>)
      .markForCheck();
  }
}
